import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { useAuth, catName } from "../context/AuthContext";
import { AdvertCard } from "../pages/Adverts";

export default function PopularServices() {
  const { cats } = useAuth();
  const [d, setD] = useState(null);
  const [tab, setTab] = useState("");
  useEffect(() => { api.get("/adverts/popular", { params: { category: tab } }).then((r) => setD(r.data)).catch(() => setD(null)); }, [tab]);
  if (!d?.categories?.length) return null;
  return (
    <section className="container-x py-16 lg:py-20" data-testid="home-popular-services">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
        <div><span className="eyebrow">Popular services</span><h2 className="h2 mt-2">Book a fixed-price service in minutes</h2></div>
        <Link to={`/adverts${d.category ? `?category=${d.category}` : ""}`} className="btn-ghost" data-testid="popular-view-all">View all {catName(cats, d.category)} <ArrowRight size={16} /></Link>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-2 mb-6 -mx-1 px-1" role="tablist">
        {d.categories.map((c) => (
          <button key={c.slug} role="tab" aria-selected={d.category === c.slug} onClick={() => setTab(c.slug)}
            className={`shrink-0 rounded-full px-4 py-2 text-sm font-semibold transition-colors ${d.category === c.slug ? "bg-[#374B5C] text-white" : "bg-white border border-slate-200 text-slate-700 hover:border-[#FF8267] hover:text-[#FF8267]"}`} data-testid={`popular-tab-${c.slug}`}>
            {catName(cats, c.slug)}</button>))}
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 stagger" data-testid="popular-grid">{d.adverts.map((a) => <AdvertCard key={a.id} a={a} />)}</div>
    </section>
  );
}
